import gsap from 'gsap';
import React, { useLayoutEffect, useState } from 'react';
import {
  createRippleEffectRelative,
  getScreenName,
} from '../../../Utils/helper';
import { assessmentText } from '../../QnaPage/AssessmentStrip/instrumentation';
import {
  CheckboxLabel,
  RadioInputSection,
  RadioOption,
  WhereShouldReach,
} from '../HealthPlan/styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function CheckboxInputField(props) {
  const {
    element,
    inputFieldErrorHandler,
    index,
    inputFieldError,
    showNewUI,
    currentQuestionAnswer = '',
    inAppForm,
  } = props;
  // const checkedValue = useRef("false");

  const initalStateValue = element?.options?.filter((option) => {
    return currentQuestionAnswer.includes(option);
  });

  const [checkboxVal, setCheckboxVal] = useState(initalStateValue);
  const handler = (e) => {
    const checkBoxArray = [...checkboxVal];
    const curr = e.target.value;

    if (e.target.checked) {
      checkBoxArray.push(e.target.value);
    } else {
      let index = -1;
      for (let i = 0; i < checkBoxArray.length; i++) {
        if (checkBoxArray[i] === curr) {
          index = i;
          break;
        }
      }
      if (index != -1) checkBoxArray.splice(index, 1);
    }
    // console.log(checkBoxArray);
    // if (document.getElementById("checkbox").checked) {
    //     checkedValue.current = e.target.value;
    // } else checkedValue.current = "false";
    if (!inAppForm) {
      fireEvent({
        category: 'entered_data',
        screen_name: getScreenName(),
        sku_type: assessmentText,
        page_url: typeof window != 'undefined' ? window.location.href : 'NA',
        parent: assessmentText,
        name: element?.question_text,
        value: checkBoxArray,
      });
    }
    setCheckboxVal(checkBoxArray);

    if (checkBoxArray.length == 0) {
      inputFieldErrorHandler(checkBoxArray.join(','), index, true);
    } else inputFieldErrorHandler(checkBoxArray.join(','), index);
  };
  const clickHandler = (e, i) => {
    createRippleEffectRelative(
      e,
      document.getElementById(index + 'checkbox' + i),
    );
  };
  useLayoutEffect(() => {
    const mainTimeline = gsap.timeline({
      ease: 'bounce.out',
    });
    const arr = gsap.utils.toArray('.radioOptions');
    const heading = document.querySelector('h2');
    const anim = gsap.from(
      arr,
      {
        transform: 'translate(300px,0px)',
        webkitTransform: 'translate(300px,0px)',
        autoAlpha: 0,
        stagger: 0.1,
        duration: 0.4,
      },
      '<',
    );
    const headingAnim = gsap.from(heading, {
      autoAlpha: 0,
      duration: 0.4,
    });
    mainTimeline.add(headingAnim);
    mainTimeline.add(anim);
  }, [element]);
  return (
    <WhereShouldReach>
      <RadioInputSection showNewUI={showNewUI}>
        <h2>{element?.question_text}</h2>{' '}
        {element?.options.map((option, idx) => {
          return (
            <RadioOption
              onClick={(e) => {
                clickHandler(e, idx);
              }}
              id={index + 'checkbox' + idx}
              showNewUI
              key={`checkbox${idx}`}
              className="radioOptions"
              checkBoxRadio={true}
            >
              <input
                type="checkbox"
                id={'checkbox' + idx}
                name="checkbox"
                onChange={(e) => handler(e)}
                value={option}
                defaultChecked={
                  checkboxVal.includes(option) ||
                  checkboxVal.includes(option?.trim())
                }
              />
              <CheckboxLabel for={'checkbox' + idx}>{option}</CheckboxLabel>
            </RadioOption>
          );
        })}
      </RadioInputSection>
    </WhereShouldReach>
  );
}
